import { Pencil } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCatalogs } from "@/lib/lookups";
import { EMPTY, displayValue } from "@/lib/finance";

export const Section = ({ title, action, children, testid }) => (
  <section data-testid={testid} className="c-card p-4">
    <div className="flex items-center justify-between mb-2 gap-2">
      <h2 className="font-mono text-[10px] tracking-[0.2em] uppercase c-muted">{title}</h2>
      {action}
    </div>
    {children}
  </section>
);

export const EditAction = ({ onClick, label = "Editar", testid = "detail-edit-btn" }) => (
  <button data-testid={testid} onClick={onClick} className="flex items-center gap-1 text-xs font-semibold c-accent"><Pencil className="w-3.5 h-3.5" /> {label}</button>
);

export const DetailFields = ({ fields, item, onEdit, title = "Datos" }) => {
  const { isOwner } = useAuth();
  const cats = useCatalogs();
  return (
    <Section title={title} testid="detail-fields" action={onEdit && <EditAction onClick={onEdit} />}>
      <dl className="divide-y c-line">
        {fields.filter((f) => !f.ownerOnly || isOwner).map((f) => {
          const v = displayValue(f, item, cats);
          return (
            <button key={f.key} type="button" onClick={onEdit} data-testid={`detail-field-${f.key.replace(/_/g, "-")}`} className="w-full flex justify-between gap-4 py-2.5 text-left">
              <dt className="text-sm c-text-2 shrink-0">{f.label}</dt>
              <dd className={`text-sm text-right break-words min-w-0 ${v == null ? "italic c-muted" : "font-medium"}`}>{v ?? EMPTY}</dd>
            </button>
          );
        })}
      </dl>
    </Section>
  );
};
